<template>
    <div> 
        <div class="d-sm-flex justify-content-center col-12">
            <vc-calendar
                :attributes='attributes'
                :min-date='getMinDateCalendar()'
                :max-date='getMaxDateCalendar()'
            />
        </div>
        <div 
            v-if="this.errorCalendario"
            class="d-sm-flex justify-content-center col-12"
        >
            Ha ocurrido un error descargando los datos del calendario.
        </div>
    </div>
</template>

<script>
    import {GET_CALENDARIO_MONTH_DATA} from "@/core/services/store/liquidacion.module";

    export default {
        name: "calendario-pagos",
        data() {
            return {
                errorCalendario: false,
                fechaLimite1: null,
                fechaLimite2: null,
                fechaLimite3: null,
                fechaPago1: null,
                fechaPago2: null,
                fechaPago3: null,
                textoLimite1: "",
                textoLimite2: "",
                textoLimite3: "",
                textoPago1: "",
                textoPago2: "",
                textoPago3: "",
            }
        },
        computed: {
            attributes(){
                return [
                    {
                        key: "Envio Liquidaciones 1",
                        highlight: {
                            contentStyle: {              // Text styles
                                color: '#ED6E3C'
                            },
                            fillMode: 'outline',
                        },
                        // dates: this.getCurrentDateByDay(12),
                        dates: this.fechaLimite1,
                        popover: {
                            // label: "Fecha Límite: para cargar facturas o boletas y recibir el pago el día 15.",
                            label: this.textoLimite1,
                            hideIndicator: true,
                        },
                    },
                    {
                        key: "Envio Liquidaciones 2",
                        highlight: {
                            contentStyle: {              // Text styles
                                color: '#ED6E3C'
                            },
                            fillMode: 'outline',
                        },
                        // dates: this.getCurrentDateByDay(18),
                        dates: this.fechaLimite2,
                        popover: {
                            // label: "Fecha Límite: para cargar facturas o boletas y recibir el pago el día 22.",
                            label: this.textoLimite2,
                            hideIndicator: true,
                        },
                    },
                    {
                        key: "Envio Liquidaciones 3",
                        highlight: {
                            contentStyle: {              // Text styles
                                color: '#ED6E3C'
                            },
                            fillMode: 'outline',
                        },
                        // dates: this.getCurrentDateByDay(25),
                        dates: this.fechaLimite3,
                        popover: {
                            // label: "Fecha Límite: para cargar facturas o boletas y recibir el pago el día 29.",
                            label: this.textoLimite3,
                            hideIndicator: true,
                        },
                    },
                    {
                        key: "Dia Pago 1",
                        highlight: {
                            style: {                     // Circle styles
                                background: '#007DA5'
                            },
                            contentStyle: {              // Text styles
                                color: 'white',
                                fontStyle: 'italic',
                            },
                            fillMode: 'solid',
                            // contentClass: 'italic',
                        },
                        // dates: this.getCurrentDateByDay(15),
                        dates: this.fechaPago1,
                        popover: {
                            // label: "Fecha Pago: facturas o boletas a pagar cargadas hasta el día 12 a las 9:00 AM.",
                            label: this.textoPago1,
                            hideIndicator: true,
                        },
                    },
                    {
                        key: "Dia Pago 2",
                        highlight: {
                            style: {                     // Circle styles
                                background: '#007DA5'
                            },
                            contentStyle: {              // Text styles
                                color: 'white',
                                fontStyle: 'italic',
                            },
                            fillMode: 'solid',
                            // contentClass: 'italic',
                        },
                        // dates: this.getCurrentDateByDay(22),
                        dates: this.fechaPago2,
                        popover: {
                            // label: "Fecha Pago: facturas o boletas a pagar cargadas hasta el día 18 a las 9:00 AM.",
                            label: this.textoPago2,
                            hideIndicator: true,
                        },
                    },
                    {
                        key: "Dia Pago 3",
                        highlight: {
                            style: {                     // Circle styles
                                background: '#007DA5'
                            },
                            contentStyle: {              // Text styles
                                color: 'white',
                                fontStyle: 'italic',
                            },
                            fillMode: 'solid',
                            // contentClass: 'italic',
                        },
                        // dates: this.getCurrentDateByDay(29),
                        dates: this.fechaPago3,
                        popover: {
                            // label: "Fecha Pago: facturas o boletas a pagar cargadas hasta el día 25 a las 9:00 AM.",
                            label: this.textoPago3,
                            hideIndicator: true,
                        },
                    },
                ]
            },
        },
        methods: {
            getTodayMonth(){
                const today = new Date()
                return today.getMonth()
            },
            getTodayYear(){
                const today = new Date()
                return today.getFullYear()
            },
            getMaxDays(){
                return new Date(this.getTodayYear(), this.getTodayMonth() + 1, 0).getDate() 
            },
            getMinDateCalendar(){
                return new Date(this.getTodayYear(), this.getTodayMonth(), 1)
            },
            getMaxDateCalendar(){
                return new Date(this.getTodayYear(), this.getTodayMonth(), this.getMaxDays())
            },
            getCurrentDateByDay(day){
                return new Date(this.getTodayYear(), this.getTodayMonth(), day)
            },
            getMonthCalendario(){
                var mes = this.getTodayMonth() + 1
                var anio = this.getTodayYear()
                
                this.$store
                .dispatch(GET_CALENDARIO_MONTH_DATA, {
                    mes: mes,
                    anio: anio,
                })
                .then((resultado) => {
                    // console.log("resultado: ", resultado)

                    if(resultado != ""){
                        this.errorCalendario = false

                        this.fechaLimite1 = new Date(resultado.fechaLimite1)
                        this.fechaLimite2 = new Date(resultado.fechaLimite2)
                        this.fechaLimite3 = new Date(resultado.fechaLimite3)
                        this.fechaPago1 = new Date(resultado.fechaPago1)
                        this.fechaPago2 = new Date(resultado.fechaPago2)
                        this.fechaPago3 = new Date(resultado.fechaPago3)

                        this.textoLimite1 = `Fecha Límite: para cargar facturas o boletas y recibir el pago el día ${this.fechaPago1.getDate()}.`,
                        this.textoLimite2 = `Fecha Límite: para cargar facturas o boletas y recibir el pago el día ${this.fechaPago2.getDate()}.`,
                        this.textoLimite3 = `Fecha Límite: para cargar facturas o boletas y recibir el pago el día ${this.fechaPago3.getDate()}.`,
                        this.textoPago1 = `Fecha Pago: facturas o boletas a pagar cargadas hasta el día ${this.fechaLimite1.getDate()} a las 9:00 AM.`
                        this.textoPago2 = `Fecha Pago: facturas o boletas a pagar cargadas hasta el día ${this.fechaLimite2.getDate()} a las 9:00 AM.`
                        this.textoPago3 = `Fecha Pago: facturas o boletas a pagar cargadas hasta el día ${this.fechaLimite3.getDate()} a las 9:00 AM.`

                    } else{
                        // console.log("Error")
                        this.errorCalendario = true
                    }
                })
                .catch((error) => {
                    this.makeToast(
                        false,
                        "Ha currido un problema al cargar los datos del calendario",
                        "Aviso",
                        "danger"
                    )
                })
            }
        },
        mounted() {
            this.getMonthCalendario()
        },
    }
</script>